<template>
  <VBtn :class="$style.headerCartBtn"
        v-bind="$attrs"
        flat
        icon
        color="grey.lighten-3"
        v-on="$listeners"
  >
    <div :class="$style.headerCart">
      <svg v-svg
           :class="$style.headerCartIcon"
           symbol="cart-icon-kiosk"
           size="18"/>
      <span :class="$style.cartBadge">
        {{ cartLength }}
      </span>
    </div>
  </VBtn>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter } from 'vuex-class';

/**
 * Button to display cart and items count.
 */
@Component()
export default class MobileCartButton extends Vue {
  @Getter cartLength;
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
@import "~@/style/helpers.scss";

.headerCartBtn {
  margin: 0;
}

.headerCart {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 23px;
  position: relative;
  outline: none;

  .headerCartIcon {
    width: 18px;
    height: 18px;
    fill: $black;
  }
}

.cartBadge {
  position: absolute;
  top: -9px;
  right: -9px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: $green2;
  color: $white;
  text-align: center;
  font-family: $main-font-family;
  font-weight: 700;
  font-size: rem(9px);
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileCartButton.vue